// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8adf4529","455":"4e852a7a","977":"43fa5c79"}[chunkId] + ".chunk.js";
};